import { Base_Uuid } from '@cadexchanger/web-toolkit'
import { createStyles, makeStyles } from '@material-ui/core'
import { useContext, useEffect, useState } from 'react'
import { CadExContext } from '../context/CadExContext'
import { Explosion } from './Explosion'
import { Measurement } from './Measurement'
import { ModelExplorer } from './ModelExplorer'
import { ModelNode } from '../types'
import { FitAll } from './FitAll'
import { CadExHelperTutorials } from './CadExHelperTutorials'

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      position: 'absolute',
      width: '100%',
      height: '100%',
    },
    toolboxBar: {
      position: 'absolute',
      height: '100%',
      width: '100px',
      display: 'flex',
      flexDirection: 'column',
      padding: '5px 20px',

      '& > *': {
        zIndex: '3',
      },
    },
  })
)

const configureFeatures = (treeModel: Map<Base_Uuid, ModelNode>) => {
  return {
    explosion: treeModel.size > 2,
  }
}

export const CadExToolbox = () => {
  const cn = useStyles()
  const [currentOperation, setCurrentOperation] = useState('')
  const [features, setFeatures] = useState({ explosion: false })

  const { getContext } = useContext(CadExContext)
  const { viewPort, treeModel, scene } = getContext()

  useEffect(() => {
    if (!treeModel) return

    setFeatures(configureFeatures(treeModel))
  }, [treeModel])

  const onMeasurementToolChange = (measurementType: string) => {
    setCurrentOperation(measurementType)
  }

  return (
    <div className={cn.root}>
      <CadExHelperTutorials operation={currentOperation} />
      <div className={cn.toolboxBar}>
        <FitAll viewPort={viewPort} />

        <Measurement
          scene={scene}
          viewPort={viewPort}
          onMeasurementToolChange={onMeasurementToolChange}
        />

        {features.explosion && <Explosion viewPort={viewPort} />}
      </div>
      <ModelExplorer />
    </div>
  )
}
